import { render, staticRenderFns } from "./ImgPreview.vue?vue&type=template&id=0666c332&scoped=true&"
import script from "./ImgPreview.vue?vue&type=script&lang=js&"
export * from "./ImgPreview.vue?vue&type=script&lang=js&"
import style0 from "./ImgPreview.vue?vue&type=style&index=0&id=0666c332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0666c332",
  null
  
)

export default component.exports